import React from 'react'
import classes from './Alert.scss'

export const Alert = ({ message, closeAlertModal }) => {
  return (<div>
    <div className={classes.overlay} onClick={closeAlertModal} />
    <div className={classes.box}>
        <h2>{message}</h2>
        <span onClick={closeAlertModal} className={classes.closeModal}><i className={['fa', 'fa-times-circle'].join(' ')}></i></span>
    </div>
  </div>)
}

export default Alert



/** WEBPACK FOOTER **
 ** ./src/components/Alert/Alert.js
 **/